const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogSetor(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogSetor`, params);
    },
    $obterRelatorioLogCSVSetor(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeSetorCsv`, params);
    },
    $obterRelatorioLogPDFSetor(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDeSetorPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;